// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FullAnalysisSelectFilePopup_head{
    display: flex;
    justify-content: space-between;
}

.FullAnalysisSelectFilePopup_head_title{
    font-weight: 600;
}

.FullAnalysisSelectFilePopup_buttons{
    display: flex;
    gap: 10px;
    justify-content: flex-end;
    align-items: flex-end;
}

.FullAnalysisSelectFilePopup_scroll{
    height: 100%;
    overflow: hidden;
}

.FullAnalysisSelectFilePopup_scroll_wrap{
    --gradientColor: #fff;
    --gradientEmptyColor: #fff0;
}

.FullAnalysisSelectFilePopup_scroll_content{
    padding-right: 16px;
    padding-bottom: 12px;
    display: flex;
    flex-direction: column;
}

.FullAnalysisSelectFilePopup_shadow{
    z-index: 1;
}

.FullAnalysisSelectFilePopup_preview{
    padding-top: 20px;
}

.FullAnalysisSelectFilePopup{
    z-index: 1;
    .GoodScroll_gradient_top{
        background-image: linear-gradient(180deg, #fff 0%, #fff0 100%);
    }

    .GoodScroll_gradient_bottom{
        background-image: linear-gradient(0deg, #fff 0%, #fff0 100%);
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/dashboardPage/components/fullAnalysis/FullAnalysisSelectFilePopup.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV;QACI,8DAA8D;IAClE;;IAEA;QACI,4DAA4D;IAChE;AACJ","sourcesContent":[".FullAnalysisSelectFilePopup_head{\n    display: flex;\n    justify-content: space-between;\n}\n\n.FullAnalysisSelectFilePopup_head_title{\n    font-weight: 600;\n}\n\n.FullAnalysisSelectFilePopup_buttons{\n    display: flex;\n    gap: 10px;\n    justify-content: flex-end;\n    align-items: flex-end;\n}\n\n.FullAnalysisSelectFilePopup_scroll{\n    height: 100%;\n    overflow: hidden;\n}\n\n.FullAnalysisSelectFilePopup_scroll_wrap{\n    --gradientColor: #fff;\n    --gradientEmptyColor: #fff0;\n}\n\n.FullAnalysisSelectFilePopup_scroll_content{\n    padding-right: 16px;\n    padding-bottom: 12px;\n    display: flex;\n    flex-direction: column;\n}\n\n.FullAnalysisSelectFilePopup_shadow{\n    z-index: 1;\n}\n\n.FullAnalysisSelectFilePopup_preview{\n    padding-top: 20px;\n}\n\n.FullAnalysisSelectFilePopup{\n    z-index: 1;\n    .GoodScroll_gradient_top{\n        background-image: linear-gradient(180deg, #fff 0%, #fff0 100%);\n    }\n\n    .GoodScroll_gradient_bottom{\n        background-image: linear-gradient(0deg, #fff 0%, #fff0 100%);\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
